import React, { useState, useEffect } from "react";
import { useTournament } from "../TournamentContext";
import {
  fetchGames,
  fetchTeams,
  fetchDivisions,
  saveSelectedGames,
  deleteSelectedGames,
  getTeamsForDivision,
  handleFieldChange,
} from "./AdminUIhelper";


const ManageGames = () => {
  const { tournamentID } = useTournament();
  const token = localStorage.getItem("token");

  const [games, setGames] = useState([]);
  const [teams, setTeams] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedGames, setSelectedGames] = useState([]);
  const [editData, setEditData] = useState({});

  const loadData = async () => {
    if (!tournamentID) return;
    setGames(await fetchGames(tournamentID));
    setTeams(await fetchTeams(tournamentID));
    setDivisions(await fetchDivisions(tournamentID));
  };

  useEffect(() => {
    loadData();
  }, [tournamentID]);

  const onSelect = (gameId) => {
    setSelectedGames((prev) =>
      prev.includes(gameId) ? prev.filter((id) => id !== gameId) : [...prev, gameId]
    );
  };

  const handleUpdate = async () => {
    await saveSelectedGames({
      tournamentID,
      token,
      selectedGames,
      editData,
      onSuccess: async () => {
        await loadData();
        setEditData({});
        setSelectedGames([]);
        alert("Games updated successfully");
      },
    });
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete selected games?")) return;
    await deleteSelectedGames({
      tournamentID,
      token,
      selectedGames,
      onSuccess: async () => {
        await loadData();
        setSelectedGames([]);
        alert("Games deleted successfully");
      },
    });
  };

  return (
    <div>
      <h2>Manage Games</h2>
     
       <table border="1" cellPadding="5">
      <thead>
        <tr>
          <th>Select</th>
          <th>Team 1</th>
          <th>Team 2</th>
          <th>Division</th>
          <th>Court</th>
          <th>Date</th>
          <th>Time</th>
          <th>Referee?</th>
          <th>Score T1</th>
          <th>Score T2</th>
          <th>Round</th>
        </tr>
      </thead>
      <tbody>
        {games.map((game) => {
          const currentDivisionId =
            editData[game._id]?.division || game.division?._id;
          const filteredTeams = getTeamsForDivision(teams, currentDivisionId);

          return (
            <tr key={game._id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedGames.includes(game._id)}
                  onChange={() => onSelect(game._id)}
                />
              </td>

              {/* Team 1 */}
              <td>
                <select
                  value={editData[game._id]?.team1 ?? game.team1?._id ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "team1", e.target.value)
                  }
                >
                  <option value="">Select Team</option>
                  {filteredTeams.map((team) => (
                    <option key={team._id} value={team._id}>
                      {team.name}
                    </option>
                  ))}
                </select>
              </td>

              {/* Team 2 */}
              <td>
                <select
                  value={editData[game._id]?.team2 ?? game.team2?._id ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "team2", e.target.value)
                  }
                >
                  <option value="">Select Team</option>
                  {filteredTeams.map((team) => (
                    <option key={team._id} value={team._id}>
                      {team.name}
                    </option>
                  ))}
                </select>
              </td>

              {/* Division */}
              <td>
                <select
                  value={currentDivisionId ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "division", e.target.value)
                  }
                >
                  <option value="">Select Division</option>
                  {divisions.map((div) => (
                    <option key={div._id} value={div._id}>
                      {div.name}
                    </option>
                  ))}
                </select>
              </td>

              <td>
                <input
                  type="number"
                  value={editData[game._id]?.court ?? game.court ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "court", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="date"
                  value={editData[game._id]?.date ?? game.date ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "date", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="time"
                  value={editData[game._id]?.time ?? game.time ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "time", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="checkbox"
                  checked={editData[game._id]?.isReferee ?? game.isReferee}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "isReferee", e.target.checked)
                  }
                />
              </td>

              <td>
                <input
                  type="number"
                  value={editData[game._id]?.scoreTeam1 ?? game.scoreTeam1 ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "scoreTeam1", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="number"
                  value={editData[game._id]?.scoreTeam2 ?? game.scoreTeam2 ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "scoreTeam2", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="number"
                  value={editData[game._id]?.round ?? game.round ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) =>
                    handleFieldChange(editData, setEditData, game._id, "round", e.target.value)
                  }
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
      <div style={{ marginTop: "15px" }}>
        <button onClick={handleUpdate} disabled={!selectedGames.length}>
          Update Selected
        </button>
        &nbsp;
        <button onClick={handleDelete} disabled={!selectedGames.length}>
          Delete Selected
        </button>
      </div>
    </div>
  );
};

export default ManageGames;
